var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import { getEventByHash } from './functions';

import ModuleCalendar from './ModuleCalendar';

var ListEvents = function (_React$Component) {
    _inherits(ListEvents, _React$Component);

    function ListEvents() {
        var _temp, _this, _ret;

        _classCallCheck(this, ListEvents);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderEvent = function (hash) {
            var events = _this.props.schedule.events;


            var event = getEventByHash(events, hash);

            return React.createElement(
                'li',
                { className: 'schedule__event' },
                React.createElement(ModuleCalendar, _extends({}, _this.props, { item: event }))
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ListEvents.prototype.render = function render() {
        var events = this.props.events;


        if (events) {
            return React.createElement(
                'ul',
                { className: 'schedule__events' },
                events.map(this.renderEvent)
            );
        }

        return false;
    };

    return ListEvents;
}(React.Component);

export default ListEvents;